/* unplugin-vue-components disabled */import { render } from "./ProFooter.vue?vue&type=template&id=62fea268&scoped=true"
import script from "./ProFooter.vue?vue&type=script&lang=js"
export * from "./ProFooter.vue?vue&type=script&lang=js"

import "./ProFooter.vue?vue&type=style&index=0&id=62fea268&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\shujukeshihuaqianduan\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62fea268"]])

export default __exports__